import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from '../ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';
import Footer from './Footer';

const AppShell = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  // Global Enter Key Listener for Homepage
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && location.pathname === '/') {
        navigate(user ? '/dashboard' : '/auth');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [location.pathname, navigate, user]);

  return (
    <div className="min-h-screen bg-[#0a0500] text-zinc-200">
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0500]/80 backdrop-blur-xl border-b border-orange-500/10 py-3' : 'bg-transparent py-5'}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group transition-all duration-300 hover:opacity-80">
            <img 
              src="https://whatastory.b-cdn.net/tools/momentoftruth/logo.svg" 
              alt="Moment of Truth Logo" 
              className="h-8 w-auto drop-shadow-[0_0_15px_rgba(234,88,12,0.3)] group-hover:drop-shadow-[0_0_25px_rgba(234,88,12,0.6)] transition-all duration-300"
            />
            <span className="text-xl font-extrabold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-amber-100 via-orange-300 to-orange-500 hidden sm:block">
              Moment of Truth
            </span>
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to={user ? "/dashboard" : "/auth"}>
              <Button variant="primary" className="text-sm px-6 py-2.5">
                {user ? "Dashboard" : "Press Enter"}
              </Button>
            </Link>
          </div>

          <button 
            className="md:hidden text-zinc-400 hover:text-amber-100 transition-colors duration-300"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-[#0a0500]/95 backdrop-blur-xl border-b border-orange-500/10 p-6 flex flex-col gap-4 md:hidden shadow-2xl">
            <Link to={user ? "/dashboard" : "/auth"} className="mt-2">
              <Button variant="primary" className="w-full !py-3">
                {user ? "Dashboard" : "Get Started"}
              </Button>
            </Link>
          </div>
        )}
      </nav>

      <main>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default AppShell;